import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import HomePageChecks from "../containers/HomePageChecks";
import HomePageAch from "../containers/HomePageAch";
import HomePageSearch from "../containers/HomePageSearch";
import HomePageReports from "../containers/HomePageReports";
import HomePageCompanyReports from "../containers/HomePageCompanyReports";
import HomePagePreferences from "../containers/HomePagePreferences";

import CheckIcon from "@material-ui/icons/ChromeReaderModeOutlined";
import ACHIcon from "@material-ui/icons/CreditCardOutlined";
import SearchIcon from "@material-ui/icons/PageviewOutlined";
import ReportsIcon from "@material-ui/icons/DescriptionOutlined";
import CompanyReportsIcon from "@material-ui/icons/ViewListOutlined";
import PreferencesIcon from "@material-ui/icons/SettingsApplicationsOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },
  disabledButton: {
    backgroundColor: theme.palette.secondary.main,
    fontWeight: "bold",
  },
});

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      preferences: {},
      companyReports: [],
      currentSelection: 0,
    };
    this.onPrefChange = this.onPrefChange.bind(this);
  }

  onPrefChange(prefs) {
    this.setState({ preferences: prefs });
  }

  componentDidMount() {
    fetch("on_home_page_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          let prefs = reply.preferences;
          let curSelect;
          if (
            prefs.checkSuspects &&
            !this.props.uiExclusionsList.includes("CHECKS")
          ) {
            curSelect = 1;
          } else if (
            prefs.achSuspects &&
            !this.props.uiExclusionsList.includes("ACH")
          ) {
            curSelect = 2;
          } else if (
            prefs.search &&
            !this.props.uiExclusionsList.includes("SEARCH")
          ) {
            curSelect = 3;
          } else if (
            prefs.reports &&
            !this.props.uiExclusionsList.includes("REPORTS")
          ) {
            curSelect = 4;
          } else if (
            prefs.companyReports &&
            !this.props.uiExclusionsList.includes("REPORTS")
          ) {
            curSelect = 6;
          } else {
            curSelect = 5;
          }
          this.setState({ preferences: prefs });
          this.setState({ currentSelection: curSelect });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleButtonClick(event, action) {
    this.setState({ currentSelection: action });
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    return (
      <div>
        {this.state.errorString.length > 0 && (
          <div className={classes.toolbar}>
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          </div>
        )}
        {this.state.errorString.length === 0 && (
          <Paper className={classes.toolbar}>
            <Toolbar>
              <Typography variant="h6" color="primary">
                {t("dailyTask.label")}&nbsp;
              </Typography>

              {this.state.preferences.checkSuspects &&
                !this.props.uiExclusionsList.includes("CHECKS") && (
                  <Tooltip title={t("viewCheckSuspects.tip")}>
                    <Button
                      variant="outlined"
                      classes={{
                        root: classes.button,
                        disabled: classes.disabledButton,
                      }}
                      color="primary"
                      onClick={(event) => this.handleButtonClick(event, 1)}
                      disabled={this.state.currentSelection === 1}
                    >
                      <CheckIcon />
                      &nbsp;{t("checkSuspects.button")}
                    </Button>
                  </Tooltip>
                )}
              {this.state.preferences.achSuspects &&
                !this.props.uiExclusionsList.includes("ACH") && (
                  <Button
                    variant="outlined"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    color="primary"
                    onClick={(event) => this.handleButtonClick(event, 2)}
                    disabled={this.state.currentSelection === 2}
                  >
                    <ACHIcon />
                    &nbsp;{t("achSuspects.button")}
                  </Button>
                )}
              {this.state.preferences.search &&
                !this.props.uiExclusionsList.includes("SEARCH") && (
                  <Button
                    variant="outlined"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    color="primary"
                    onClick={(event) => this.handleButtonClick(event, 3)}
                    disabled={this.state.currentSelection === 3}
                  >
                    <SearchIcon />
                    &nbsp;{t("search.button")}
                  </Button>
                )}
              {this.state.preferences.reports &&
                !this.props.uiExclusionsList.includes("REPORTS") && (
                  <Button
                    variant="outlined"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    color="primary"
                    onClick={(event) => this.handleButtonClick(event, 4)}
                    disabled={this.state.currentSelection === 4}
                  >
                    <ReportsIcon />
                    &nbsp;{t("reports.button")}
                  </Button>
                )}
              {this.state.preferences.companyReports &&
                !this.props.uiExclusionsList.includes("REPORTS") && (
                  <Button
                    variant="outlined"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    color="primary"
                    onClick={(event) => this.handleButtonClick(event, 6)}
                    disabled={this.state.currentSelection === 6}
                  >
                    <CompanyReportsIcon />
                    &nbsp;{t("companyReports.button")}
                  </Button>
                )}
              <Button
                variant="outlined"
                classes={{
                  root: classes.button,
                  disabled: classes.disabledButton,
                }}
                color="primary"
                onClick={(event) => this.handleButtonClick(event, 5)}
                disabled={this.state.currentSelection === 5}
              >
                <PreferencesIcon />
                &nbsp;{t("preferences.button")}
              </Button>
            </Toolbar>
          </Paper>
        )}
        <div className={classes.tableWrapper}>
          {this.state.currentSelection === 1 && (
            <div>
              <HomePageChecks
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                prefs={this.state.preferences}
              />
            </div>
          )}
          {this.state.currentSelection === 2 && (
            <div>
              <HomePageAch
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                prefs={this.state.preferences}
              />
            </div>
          )}
          {this.state.currentSelection === 3 && (
            <div>
              <HomePageSearch
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                prefs={this.state.preferences}
              />
            </div>
          )}
          {this.state.currentSelection === 4 && (
            <div>
              <HomePageReports
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                prefs={this.state.preferences}
              />
            </div>
          )}
          {this.state.currentSelection === 6 && (
            <div>
              <HomePageCompanyReports
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                prefs={this.state.preferences}
              />
            </div>
          )}
          {this.state.currentSelection === 5 && (
            <div>
              <HomePagePreferences
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                prefs={this.state.preferences}
                onPrefChange={this.onPrefChange}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePage));
